import { LawyerReducer } from "./lawyerSlice";

const selectAll = (state: LawyerReducer) => state.lawyer;

const selectFirstName = (state: LawyerReducer) => selectAll(state).firstName;
const selectLastName = (state: LawyerReducer) => selectAll(state).lastName;
const selectFullName = (state: LawyerReducer) =>
  `${selectFirstName(state)} ${selectLastName(state)}`;
const selectPronouns = (state: LawyerReducer) => selectAll(state).pronouns;
const selectTitle = (state: LawyerReducer) => selectAll(state).title;
const selectEmail = (state: LawyerReducer) => selectAll(state).email;
const selectAddress = (state: LawyerReducer) => selectAll(state).address;
const selectPracticeName = (state: LawyerReducer) =>
  selectAll(state).practiceName;
const selectWebsite = (state: LawyerReducer) => selectAll(state).website;
const selectAvatarSrc = (state: LawyerReducer) => selectAll(state).avatarSrc;
const selectAvatarName = (state: LawyerReducer) => selectAll(state).avatarName;
const selectUid = (state: LawyerReducer) => selectAll(state).uid;
const selectRole = (state: LawyerReducer) => selectAll(state).role;
const selectTimeTrackingEnabled = (state: LawyerReducer) =>
  Boolean(selectAll(state).time_tracking_enabled);
const selectLegacyDrafting = (state: LawyerReducer) =>
  Boolean(selectAll(state).legacyDrafting);
const selectHasAcceptedTerms = (state: LawyerReducer) =>
  selectAll(state).hasAcceptedTerms;
const selectHideQualityReview = (state: LawyerReducer) =>
  selectAll(state).hideQualityReview;
const selectBetaFeatures = (state: LawyerReducer) =>
  selectAll(state).betaFeatures;
const selectHiddenPrompts = (state: LawyerReducer) =>
  selectAll(state).hiddenPrompts ?? [];
const selectEntitlements = (state: LawyerReducer) =>
  selectAll(state).entitlements;
const selectOnboardingStatus = (state: LawyerReducer) =>
  selectAll(state).onboardingStatus ?? null;

const selectExhbitListFormat = (state: LawyerReducer) =>
  selectAll(state).exhibitListFormat;

const selectOrganizeInstruction = (state: LawyerReducer) =>
  selectAll(state).organizeInstruction ?? "";
const selectDocumentTitleStyle = (state: LawyerReducer) =>
  selectAll(state).documentTitleStyle ?? "";
const selectSubagentModel = (state: LawyerReducer) =>
  selectAll(state).subagentModel ?? "";
const selectSubagentThinking = (state: LawyerReducer) =>
  selectAll(state).subagentThinking ?? false;

export const lawyerSelectors = {
  selectAll,
  selectFirstName,
  selectLastName,
  selectFullName,
  selectPronouns,
  selectTitle,
  selectEmail,
  selectAddress,
  selectPracticeName,
  selectWebsite,
  selectAvatarSrc,
  selectAvatarName,
  selectUid,
  selectRole,
  selectTimeTrackingEnabled,
  selectLegacyDrafting,
  selectHasAcceptedTerms,
  selectHideQualityReview,
  selectBetaFeatures,
  selectHiddenPrompts,
  selectEntitlements,
  selectOnboardingStatus,
  selectExhbitListFormat,
  selectOrganizeInstruction,
  selectDocumentTitleStyle,
  selectSubagentModel,
  selectSubagentThinking
};
